import { apiGET, apiPUT } from './api';

export const getSettings = () => apiGET('/settings');

export const updateSettings = settings => apiPUT('/settings', settings);
